export function BrandMark({ className = 'size-9' }: { className?: string }) {
  return (
    <svg
      aria-hidden="true"
      className={className}
      data-testid="brand-mark"
      viewBox="0 0 64 64"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="64" height="64" rx="16" fill="#102f50" />
      <path d="M13 21C23 10 43 8 53 18" fill="none" stroke="#ffffff" strokeOpacity=".14" strokeWidth="2" strokeLinecap="round" />
      <path d="M15 45 29 17l15 28" fill="none" stroke="#ffffff" strokeWidth="4.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="m20 35 19-.5M29 17l20 11-5 17" fill="none" stroke="#e7a6b3" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
      <circle cx="29" cy="17" r="4" fill="#e7a6b3" />
      <circle cx="15" cy="45" r="3.25" fill="#ffffff" />
      <circle cx="44" cy="45" r="3.25" fill="#ffffff" />
      <circle cx="49" cy="28" r="3.25" fill="#e7a6b3" />
    </svg>
  )
}
